import React from 'react';
import Typography from '../../../basic/Typography';
import { NewNGJob } from '../types';
import styles from '../NewNG.module.css';

interface TheatreJobSelectorProps {
  jobs: NewNGJob[];
  currentJob: NewNGJob | null;
  onJobSelect: (job: NewNGJob) => void;
  isLoading: boolean;
}

export const TheatreJobSelector: React.FC<TheatreJobSelectorProps> = ({
  jobs,
  currentJob,
  onJobSelect,
  isLoading
}) => {
  const handleJobChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedJobId = event.target.value;
    const selectedJob = jobs.find(job => job.job_id === selectedJobId);
    if (selectedJob) {
      onJobSelect(selectedJob);
    }
  };

  return (
    <div className={styles['newng-theatre-job-selector-container']}>
      <Typography
        variant="body2"
        className={styles['newng-theatre-job-selector-label']}
        gutterBottom={false}
      >
        Select Job ID:
      </Typography>

      <select
        className={styles['newng-theatre-job-selector-dropdown']}
        value={currentJob?.job_id || ''}
        onChange={handleJobChange}
        disabled={isLoading}
      >
        {isLoading ? (
          <option value="">Loading...</option>
        ) : jobs.length > 0 ? (
          jobs.map(job => (
            <option key={job.job_id} value={job.job_id}>
              {job.job_id.substring(0, 8)} ({job.overall_status || job.status})
            </option>
          ))
        ) : (
          <option value="">No jobs found</option>
        )}
      </select>
    </div>
  );
};
